import React from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  Database,
  Workflow,
  Map,
  Users,
  Check,
  Code,
  ClipboardCheck,
} from "lucide-react";

const iconMap = { Database, BarChart3: Workflow, Map, Users, Code, ClipboardCheck };

/** Carte d'un service, entièrement cliquable vers sa page. */
export const CarteService = ({ service, TitreBalise = "h3" }) => {
  const Icon = iconMap[service.icon] || Database;
  return (
    <Link to={`/services/${service.slug}`} className="card">
      <Icon className="card-ico" strokeWidth={1.8} aria-hidden="true" />

      <TitreBalise className="text-vt-h3 font-bold text-brand">{service.title}</TitreBalise>
      <p className="mt-3 leading-relaxed text-t2">{service.description}</p>

      <ul className="mt-6 grid flex-1 content-start gap-3 border-t border-border pt-6">
        {service.capabilities.map((capability) => (
          <li key={capability} className="flex items-start gap-2.5 font-semibold">
            <Check
              className="mt-1 h-4 w-4 flex-none text-accent"
              strokeWidth={2.6}
              aria-hidden="true"
            />
            {capability}
          </li>
        ))}
      </ul>

      <span className="mt-6 inline-flex items-center gap-1.5 text-vt-controle font-bold text-brand">
        En savoir plus
        <ArrowRight className="h-[1.0625rem] w-[1.0625rem]" strokeWidth={2.4} aria-hidden="true" />
      </span>
    </Link>
  );
};
